import { render, staticRenderFns } from "./index_new.vue?vue&type=template&id=fae3009c&scoped=true"
import script from "./index_new.vue?vue&type=script&lang=js"
export * from "./index_new.vue?vue&type=script&lang=js"
import style0 from "./index_new.vue?vue&type=style&index=0&id=fae3009c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae3009c",
  null
  
)

export default component.exports